<template>
<v-app class="main">
  <v-app-bar
  app
  fixed
  flat
  height="90"
  class="main"
  >
    <a href="/" style="text-decoration: none;" :class="$vuetify.breakpoint.smAndDown ? '' : 'ml-10'">
      <v-img
        class="img mt-1"
        src="@/assets/dashmovelogo.png"
        contain
        alt="Logo"
        width="190"/>
    </a>
    <!-- <div v-if="!$vuetify.breakpoint.smAndDown" class="links ml-12">
      <router-link to="/" :class="this.$router.currentRoute.fullPath == '/' ? 'ml-12 primary--text' : 'ml-12 info--text'" style="text-decoration: none;">Home</router-link>
      <router-link to="/about" :class="this.$router.currentRoute.fullPath == '/about' ? 'ml-12 primary--text' : 'ml-12 info--text'" style="text-decoration: none;">About Us</router-link>
      <router-link to="/help" :class="this.$router.currentRoute.fullPath == '/help' ? 'ml-12 primary--text' : 'ml-12 info--text'" style="text-decoration: none;">FAQs</router-link>
    </div> -->

    <v-spacer></v-spacer>

    <v-btn
      class="mx-2 primary white--text"
      rounded
      height="50"
      width="190"
      href="tel:+27829099712"
      style="font-size: 18px; font-family: Avenir1;"
      >
      <h3>082 909 9712</h3>
    </v-btn>

    <!-- <div class="links">
      <button
        class="b1 links mx-2 primary white--text"
        @click="redirectLogin()"
        style="font-size: 16px; height: 50px; border-radius: 20px; width: 140px;"
        >
          Sign Up / Login
      </button>

       <button

        class="b2 links mr-2 primary white--text"
        @click="redirect()"
        style="font-size: 16px; height: 50px; border-radius: 20px; width: 100px;"
        >
          Sign Up
      </button>

      <button
        class="b3 links primary white--text"
        @click="redirectLogin()"
        style="font-size: 16px; height: 50px; border-radius: 20px; width: 100px;"
        >
          Login
      </button>
    </div> -->
  </v-app-bar>
  <ToastrContainer />

  <v-main class="bgColour">
    <a href="https://api.whatsapp.com/send/?phone=27722459777&text&type=phone_number&app_absent=0"  target="_blank" class="whatsapp_float">
      <span class="mdi mdi-whatsapp"></span>
    </a>
    <router-view></router-view>
  </v-main>

  <br><br><br><br/>
  <v-footer
    app
    absolute
    padless
    class="pb-10 bgColour"
    >
    <v-container fluid>
      <v-row class="px-4 footer">
        <v-row :style="$vuetify.breakpoint.smAndDown ? 'display: block;' : ''">
          <v-col class="main--text">
            <div :style="$vuetify.breakpoint.smAndDown ? 'display: inline-flex; margin-bottom: 1cm; margin-top: 0.5cm;' : ''">
              <a href="/" style="text-decoration: none;"> <v-img contain width="220" src="@/assets/dashmovelogo2.png"/> </a>
              <br/>
              <div v-if="$vuetify.breakpoint.smAndDown" class="d-flext mt-5 ml-3">
                <a href="https://www.facebook.com/wrappwaste" target="_blank" style="text-decoration: none;"><img src="@/assets/facebook.svg" width="35"/></a>
                <a href="https://www.instagram.com/dashwaste/" target="_blank" style="text-decoration: none;" class="mx-3"><img src="@/assets/instagram.svg" width="33"/></a>
                <a href="https://api.whatsapp.com/send?phone=27722459777" target="_blank" style="text-decoration: none;"><img src="@/assets/whatsapp.svg" width="35"/></a>
              </div>
            </div>
            <!-- <div v-if="$vuetify.breakpoint.smAndDown" class="trustpilot-widget" style="text-align: left;" data-locale="en-US" data-template-id="56278e9abfbbba0bdcd568bc" data-businessunit-id="66a1e6acf462e383527b634e" data-style-height="52px" data-style-width="100%">
              <a href="https://www.trustpilot.com/review/dashwaste.co.za" target="_blank" rel="noopener">Trustpilot</a>
            </div> -->
            <p>Book removals that is simple, <br v-if="!$vuetify.breakpoint.smAndDown"/> fast, and dependable.</p>
            <p><span class="primary--text">*</span> Applicable during business hours </p> <br/>
            <div v-if="!$vuetify.breakpoint.smAndDown">
              <a href="https://www.facebook.com/wrappwaste" target="_blank" style="text-decoration: none;"><img src="@/assets/facebook.svg" width="35"/></a>
              <a href="https://www.instagram.com/dashwaste/" target="_blank" style="text-decoration: none;" class="mx-3"><img src="@/assets/instagram.svg" width="33"/></a>
              <a href="https://api.whatsapp.com/send?phone=27722459777" target="_blank" style="text-decoration: none;"><img src="@/assets/whatsapp.svg" width="35"/></a>
            </div>
          </v-col>
          <!-- <v-col class="main--text mt-12" md="2">
            <h3 style="font-family: Avenir1;">Quick Links</h3><br/>
            <router-link class="main--text" style="text-decoration: none;" to="/about"> About us</router-link><br/>
            <a class="main--text" style="text-decoration: none;" href="/#testimonials"> Testimonials</a><br/>
            <router-link class="main--text" style="text-decoration: none;" to="/help"> FAQS</router-link><br/>
            <router-link class="main--text" style="text-decoration: none;" to="/driver"> Become a Service Provider</router-link><br/>
          </v-col>
          <v-col class="main--text mt-12" md="2">
            <h3 style="font-family: Avenir1;">Legal</h3><br/>
            <router-link class="main--text" style="text-decoration: none;" to="/tc"> Terms of Use</router-link><br/>
          </v-col> -->
          <v-col class="main--text mt-12" md="5">
            <h3 style="font-family: Avenir1;">Business Details</h3><br/>
            <p> Head Office: 36 Zinfandal Rd, Blackheath, Cape Town, South Africa
              <br/>Registration Number: 2007/008 563/07 <br/>
              VAT Number: 463 027 9224</p>
          </v-col>
          <v-col class="main--text mt-12" md="2">
            <h3 class="text-center" style="font-family: Avenir1;">A ZEE Group Initiative</h3><br/>
            <a href="https://www.zeegroup.co.za/" target="_blank" style="text-decoration: none;"><v-img contain height="150" src="@/assets/Zeelogo.png"/></a>
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col>
            <v-divider class="primary"></v-divider>
            <br/>
            <v-row>
              <v-col v-if="!$vuetify.breakpoint.smAndDown">
                <a href="https://www.facebook.com/wrappwaste" target="_blank" style="text-decoration: none;"><v-icon class="primary--text mr-4" large>mdi-facebook</v-icon></a>
                <a href="https://www.instagram.com/dashwaste/" target="_blank" style="text-decoration: none;"><v-icon class="primary--text mr-4" large>mdi-instagram</v-icon></a>
                <a href="https://api.whatsapp.com/send?phone=27722459777" target="_blank" style="text-decoration: none;"><v-icon class="primary--text" large>mdi-whatsapp</v-icon></a>
              </v-col>
              <v-col md="3" v-if="!$vuetify.breakpoint.smAndDown">
                <div class="trustpilot-widget" data-locale="en-US" data-template-id="56278e9abfbbba0bdcd568bc" data-businessunit-id="66a1e6acf462e383527b634e" data-style-height="52px" data-style-width="100%">
                  <a href="https://www.trustpilot.com/review/dashwaste.co.za" target="_blank" rel="noopener">Trustpilot</a>
                </div>
              </v-col>
              <v-col md="2">
                <button
                  @click="redirect()"
                  class="primary white--text"
                  style="font-size: 18px; height: 50px; border-radius: 20px; width: 100%;"
                  >
                    Sign Up
                </button>
              </v-col>
              <v-col md="2">
                <button
                  @click="redirectLogin()"
                  class="primary white--text"
                  style="font-size: 18px; height: 50px; border-radius: 20px; width: 100%;"
                  >
                    Client Login
                </button>
              </v-col>
            </v-row>
          </v-col>
        </v-row> -->
      </v-row>
    </v-container>
  </v-footer>
</v-app>
</template>

<!-- Google tag (gtag.js) -->
<script async src="https://www.googletagmanager.com/gtag/js?id=AW-987094970"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'AW-987094970');
</script>
<script>
import ToastrContainer from './components/ToastrContainer.vue';


export default {

components: {
  ToastrContainer,
},
  name: 'App',
  methods: {
    redirect(){
      window.location.href = 'https://app.dashwaste.co.za/signup';
    },
    redirectLogin(){
      window.location.href = 'https://app.dashwaste.co.za/login';
    }
  },
  mounted(){
    scrollTo(0, 0);
  }
}

</script>

<style scoped>
.whatsapp_float {
  position: fixed;
  width: 65px;
  height: 65px;
  bottom: 30px;
  right: 30px;
  background-color: #00AF66;
  color: #fff;
  border-radius: 50px;
  text-align: center;
  font-size: 42px;
  box-shadow: 2px 2px 3px #999;
  z-index: 100;
}

.bgColour{
  background-image: linear-gradient(to right, white, #D3FAE6);
}
.b1{
  display: none;
}
.links{
  font-family: Avenir2;
  font-style: normal;
  font-size: 16px;
  line-height: 20px;
  }
  .footer{
  font-family: Avenir3;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
}

@media screen and (max-width: 450px){
  .img{
    max-width: 125px;
  }
  .b1{
    display: block;
  }
  .b2, .b3{
    display: none;
  }

}
</style>
